import { Database } from '../../main/options/model/types'

function checkCollection(text: string, isNew: boolean): string | void {
    const finalCollection = String(text)
    if (finalCollection.length == 0 && isNew) return
    if (finalCollection.length == 0 && !isNew) return 'invalid collection name'
    if (!/^([a-z]\w*)$/.test(finalCollection)) {
        return `Use only letters 'a' to 'z', digits 0-9 and underscore _`
    }
}

function checkString(s: string): boolean {
    if (typeof s !== 'string' || !s) {
        return false
    }
    return s.length > 0
}

function checkIsValid(database: Database): boolean {
    if (!checkString(database.databaseName)) return false
    if (!checkString(database.eventType)) return false
    return true
}

export { checkCollection, checkIsValid }
